// Shared helpers for building schema.org JSON-LD structured data.

/**
 * Formats a review date as an ISO 8601 string for schema.org JSON-LD `datePublished`. Returns
 * undefined when there's no parseable source value, so callers omit the field rather than fabricate
 * "now". Shared by ProductReviewsJsonLd and BrandReviewsJsonLd; callers pick the source field
 * (e.g. `reviewDate ?? date`) before calling.
 */
export const getReviewDatePublished = (source?: number | string | null): string | undefined => {
  if (source === undefined || source === null) {
    return undefined;
  }
  const jsDate = new Date(source);
  return isNaN(jsDate.getTime()) ? undefined : jsDate.toISOString();
};
